import request from "@/utils/request"

// 修改密码
export function editPassword(id, oldPassword, password, smsCode, telephone) {
  return request({
    url: "/admin-user/change-password",
    method: "POST",
    data: {
      id,
      oldPassword,
      password,
      smsCode,
      telephone
    }
  })
}